// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import LazyImage, { LazyImageProps } from "@guestsupply/MobiusOverrides/LazyImage/LazyImage";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import Button, { ButtonProps } from "@insite/mobius/Button";
import Link from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";

interface SolutionsCardProps {
    title: string;
    image: string;
    destination: LinkFieldValue;
    handleButtonClick: (url: string) => void;
    buttonTitle?: string;
    backgroundColor?: string;
    handleClickCard?: (title: string, url: string | undefined) => void;
}

type Props = SolutionsCardProps;

export interface SolutionsCardStyle {
    image?: LazyImageProps;
    itemsWrapper?: InjectableCss;
    titleTypography?: TypographyProps;
    button?: ButtonProps;
    imageWrapper?: InjectableCss;
}

export const solutionsCardStyles: SolutionsCardStyle = {};

const styles = solutionsCardStyles;

const SolutionsCard: FC<Props> = ({
    title,
    image,
    destination,
    handleButtonClick,
    buttonTitle,
    backgroundColor,
    // xng-change: add google event
    handleClickCard = () => {},
}) => {
    const { url } = useGetLink(destination);

    return (
        <StyledWrapper
            key={title}
            {...styles.itemsWrapper}
            {...{ backgroundColor }}
            // xng-change: add google event
            onClick={() => handleClickCard(title, url)}
        >
            <StyledWrapper {...styles.imageWrapper}>
                <Link href={url} aria-label={title}>
                    <LazyImage
                        width="110"
                        height="110"
                        {...styles.image}
                        src={image}
                        altText={title}
                        customTransformations={{ default: "GUEST_Product_110x110" }}
                    />
                </Link>
            </StyledWrapper>
            <Typography {...styles.titleTypography}>{title}</Typography>
            <Button {...styles.button} onClick={() => handleButtonClick(url!)} aria-label={buttonTitle}>
                {buttonTitle}
            </Button>
        </StyledWrapper>
    );
};

export default SolutionsCard;
